import { render, staticRenderFns } from "./printColorSelector.vue?vue&type=template&id=2dad617f&scoped=true&"
import script from "./printColorSelector.vue?vue&type=script&lang=js&"
export * from "./printColorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dad617f",
  null
  
)

export default component.exports